import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const HostingDashboard = React.lazy(() => import("./HostingDashboard"));
const HostingOffers = React.lazy(() => import("./HostingOffers"));
const HostingReferrals = React.lazy(() => import("./HostingReferrals"));
const HostingAffiliatePage = React.lazy(() => import("./HostingAffiliatePage"));
const HostingOfferLanding = React.lazy(() => import("./HostingOfferLanding"));
const HostingSitesAdmin = React.lazy(() => import("./HostingSitesAdmin"));
const HostingLinkLanding = React.lazy(() => import("./HostingLinkLanding"));

const hostingModuleConfig: ModuleConfig = {
  // 🏷️ MODULE IDENTITY — id MUST equal backend permissions.ts moduleId
  id: "hosting",
  name: "Hosting",
  description:
    "Managed website hosting — a build page per site that reports what the hosting provider actually did (Building / Live / Failed, with the build log), hosting offers linked to subscription billing, and an affiliate program: referral links, 20% commission ledger, notification emails and monthly payouts.",
  version: "1.1.0",
  enabled: true,
  category: "business",
  order: 20,
  icon: "🌐",
  color: "#1F6FEB",

  routes: [
    // Auth-only, NOT permission-gated: a site OWNER (a plain client, e.g. Jeremy)
    // opens their own build page here — the backend scopes non-admins to the
    // sites they own (hostingSites ownership filter). Admins see everything.
    { path: "/hosting", component: HostingDashboard, useLayout: true, exact: true },
    { path: "/hosting/sites", component: HostingSitesAdmin, permissionLevel: "view", useLayout: true },
    // PUBLIC on purpose: this is where a ?k= sign-in link lands. /hosting itself
    // is behind ProtectedRoute, which would render the login modal INSTEAD of the
    // page, so the token would never be exchanged. Same shape as /theprogram/go.
    { path: "/hosting/go", component: HostingLinkLanding, public: true, useLayout: true },
    { path: "/hosting/offers", component: HostingOffers, permissionLevel: "view", useLayout: true },
    { path: "/hosting/referrals", component: HostingReferrals, permissionLevel: "view", useLayout: true },
    // Ownership-gated on the backend — any logged-in client can open it; the
    // backend answers only with THEIR affiliate rows (or none).
    { path: "/hosting/affiliate", component: HostingAffiliatePage, useLayout: true },
    // Public ?ref= landing page — anonymous. Static routes above win over :slug.
    { path: "/hosting/:slug", component: HostingOfferLanding, public: true, useLayout: false },
  ],

  navigation: [
    { label: "Hosting", path: "/hosting", icon: "🌐", permissionLevel: "view" },
    { label: "Manage sites", path: "/hosting/sites", icon: "⚙️", permissionLevel: "view" },
    { label: "Offers", path: "/hosting/offers", icon: "🏷️", permissionLevel: "view" },
    { label: "Referrals", path: "/hosting/referrals", icon: "🤝", permissionLevel: "view" },
  ],

  // EMPTY — backend permissions.ts is the single source of truth.
  permissions: { view: [], create: [], edit: [], delete: [] },
};

export default hostingModuleConfig;
